export const getClasses = (classes:any, variant = ''): string => {
    if (variant.length > 0) {
        return Object.values(classes[variant]).join(' ')
    }

    return Object.values(classes).join(' ')
}